/**
 * Action Types
 */
const headerActionTypes = {
    SET_DRAWER_ANIMATION: 'SET_DRAWER_ANIMATION',
    SET_BANNER_MESSAGES: 'SET_BANNER_MESSAGES',
    SET_UPDATE_USER_STATE: 'SET_UPDATE_USER_STATE',
    SET_USER_TYPE_TRADE: 'SET_USER_TYPE_TRADE',
    SET_USER_TYPE_VIP: 'SET_USER_TYPE_VIP',
    SET_CART_ITEMS: 'SET_CART_ITEMS',
    SET_DEVICE_TYPE: 'SET_DEVICE_TYPE',
    TOGGLE_MOBILE_MENU: 'TOGGLE_MOBILE_MENU',
    INITIAL_TRACKING_FIRED: 'INITIAL_TRACKING_FIRED'
};

const footerActionTypes = {
    SET_CURRENCY: 'SET_CURRENCY'
};

const actionTypes = {
    ...headerActionTypes,
    ...footerActionTypes
};

/**
 * Other Constants
 */

const headerActionValues = {
    drawerAnimations: {
        SLIDE_IN: 'SLIDE_IN',
        SLIDE_OUT: 'SLIDE_OUT',
        NONE: 'NONE'
    }
};

const actionValues = {
    ...headerActionValues
};

export { actionTypes, actionValues };
export default { actionTypes, actionValues };



// WEBPACK FOOTER //
// ./src/actions/constants.js